module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.stepString,
    attrs: {
      "id": "background"
    }
  }, [_c('div', {
    class: _vm.stepString,
    attrs: {
      "id": "_content"
    }
  }, [_c('video', {
    staticClass: "video-webcam",
    attrs: {
      "id": "_webcam1"
    }
  }), _vm._v(" "), _c('canvas', {
    staticClass: "video-canvas",
    attrs: {
      "id": "_imageData1"
    }
  }), _vm._v(" "), _c('canvas', {
    staticClass: "video-canvas",
    attrs: {
      "id": "_faceSub1"
    }
  }), _vm._v(" "), _c('canvas', {
    staticClass: "video-canvas",
    attrs: {
      "id": "_threejs1"
    }
  }), _vm._v(" "), _c('canvas', {
    staticClass: "video-canvas",
    attrs: {
      "id": "_drawing1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "video-canvas",
    attrs: {
      "id": "glasses"
    }
  }, [_c('div', {
    staticClass: "choices",
    on: {
      "click": _vm.goToSelfie
    }
  }, [_vm._v("\n        Cosa ne pensi di questi?"), _c('br'), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/img/schermata3/occhiale1.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/img/schermata3/occhiale2.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/img/schermata3/occhiale3.png"
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "footer",
    on: {
      "click": _vm.goToSelfie
    }
  }, [_c('div', [_vm._v("Scatta!")])])])]), _vm._v(" "), _c('div', {
    class: _vm.questionString + ' ' + _vm.stepString,
    attrs: {
      "id": "question"
    },
    on: {
      "click": _vm.highlightGlasses
    }
  }, [_vm._m(1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/showcase",
      "id": "nav-prev"
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/selfie",
      "event": '',
      "id": "nav-next"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        _vm.highlightGlasses()
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "influencer"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/schermata3/attanasio.png"
    }
  }), _vm._v(" "), _c('div', [_vm._v("Vuoi vedere la scelta di @fabioattanasio?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n      Che cosa ti ispira? "), _c('br'), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/img/schermata2/esperienza1.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/img/schermata2/esperienza2.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/img/schermata2/esperienza3.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00221f3e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Luxy.vue
// module id = 22
// module chunks = 0